import { render, staticRenderFns } from "./BookComponentGantt.vue?vue&type=template&id=9e957d68&scoped=true&"
import script from "./BookComponentGantt.vue?vue&type=script&lang=js&"
export * from "./BookComponentGantt.vue?vue&type=script&lang=js&"
import style0 from "./BookComponentGantt.vue?vue&type=style&index=0&id=9e957d68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e957d68",
  null
  
)

export default component.exports